var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShow)?_c('div',{staticClass:"form-message error"},[_vm._t("default",function(){return [(_vm.isHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}}):_c('div',[_vm._v(_vm._s(_vm.message))])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }